import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import ServiceCard from "./services/ServiceCard";
import { ServiceData } from "./services/types";

const Services = () => {
  const [services, setServices] = useState<ServiceData[]>([
    {
      title: "Facial Aesthetics",
      description: "Experience transformative facial rejuvenation with our advanced aesthetic treatments. Our expert practitioners utilize premium products and cutting-edge techniques to enhance your natural beauty.",
      images: [] as string[],
      treatments: [
        "Neurotoxins for Fine Lines & Wrinkles",
        "Premium Dermal Fillers",
        "Advanced Skin Tightening",
        "Medical-Grade Facial Treatments"
      ],
      path: "/services/facial-aesthetics",
      bucket: "injectables_images"
    },
    {
      title: "Hair Restoration",
      description: "Restore confidence with our comprehensive hair restoration solutions. Using state-of-the-art technology and proven treatments, we help you achieve natural-looking, lasting results.",
      images: [] as string[],
      treatments: [
        "Advanced PRP Hair Therapy",
        "Red Light Laser Treatment",
        "Custom Growth Protocols",
        "Scalp Health Optimization"
      ],
      path: "/services/hair-restoration",
      bucket: "hair_images"
    },
    {
      title: "IV Therapy & Body Treatments",
      description: "Revitalize your body with our personalized IV therapies and innovative body treatments. From energy boost to wellness optimization, experience the benefits of direct nutrient delivery.",
      images: [] as string[],
      treatments: [
        "Custom Vitamin Infusions",
        "Hydration & Recovery Therapy",
        "Advanced Body Contouring",
        "Targeted Wellness Solutions"
      ],
      path: "/services/iv-therapy",
      bucket: "ivtherapy_images"
    },
  ]);

  useEffect(() => {
    const fetchImagesForService = async (bucket: string) => {
      try {
        console.log(`Fetching images from ${bucket} bucket...`);
        const { data: files, error } = await supabase
          .storage
          .from(bucket)
          .list('', {
            limit: 100,
            offset: 0,
            sortBy: { column: 'name', order: 'asc' },
          });

        if (error) {
          console.error(`Error fetching images from ${bucket}:`, error);
          return [];
        }

        console.log(`Successfully fetched files from ${bucket}:`, files);

        const imageUrls = await Promise.all(
          files
            .filter(file => file.name.match(/\.(jpg|jpeg|png|gif|webp)$/i))
            .map(async (file) => {
              const { data: { publicUrl } } = supabase
                .storage
                .from(bucket)
                .getPublicUrl(file.name);
              console.log(`Generated public URL for ${file.name}:`, publicUrl);
              return publicUrl;
            })
        );

        console.log(`Final image URLs for ${bucket}:`, imageUrls);
        return imageUrls;
      } catch (error) {
        console.error(`Error fetching images from ${bucket}:`, error);
        return [];
      }
    };

    const loadAllImages = async () => {
      const updatedServices = await Promise.all(
        services.map(async (service) => ({
          ...service,
          images: await fetchImagesForService(service.bucket)
        }))
      );
      console.log('Updated services with images:', updatedServices);
      setServices(updatedServices);
    };

    loadAllImages();
  }, []);

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-serif text-center mb-16">Our Services</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service) => (
            <ServiceCard key={service.title} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;